<script setup>
import LIcon from "@/components/shared/LIcon.vue";
import { useUiStore } from "@/stores/ui";
import { MODAL_ACTIONS } from "@/utils/constants/modalActions";

const uiStore = useUiStore();
const props = defineProps({
  data: Object,
});

const resetStoreData = () => {
  uiStore.setModalState(false);
  uiStore.setModalData({});
  uiStore.setModalAction(null);
};

const action = (type, data) => {
  resetStoreData();
  uiStore.setModalAction(type);
  uiStore.setModalState(true);
  uiStore.setModalData(data);
};

const isVisible = () => props.data?.packageId != process.env.VUE_APP_PACKAGE_ID;
</script>

<template>
  <div class="actions-cell">
    <button v-if="isVisible()" @click="action(MODAL_ACTIONS.LAUNCH_APP, props.data)" type="button" class="icon-button" title="Launch">
      <LIcon name="play" />
    </button>
    <button v-if="isVisible()" @click="action(MODAL_ACTIONS.CLEAR_APP_CACHE, props.data)" type="button" class="icon-button" title="Clear Cache">
      <LIcon name="eraser" />
    </button>
    <button v-if="isVisible()" @click="action(MODAL_ACTIONS.CLEAR_APP_DATA, props.data)" type="button" class="icon-button" title="Clear Data">
      <LIcon name="trash-2" />
    </button>
    <button v-if="isVisible()" @click="action(MODAL_ACTIONS.FORCE_STOP_APP, props.data)" type="button" class="icon-button" title="Force Stop">
      <LIcon name="ban" />
    </button>
    <button v-if="isVisible()" @click="action(MODAL_ACTIONS.UNINSTALL_APP, props.data)" type="button" class="icon-button danger" title="Uninstall">
      <LIcon name="x" />
    </button>
  </div>
</template>
